import React, { useEffect, useState } from "react";
import { Modal, Typography, Table, Space } from "antd";
import dayjs from "dayjs";
import styles from "./ReviewModal.module.css";

const ReviewModal = ({
  open,
  setOpen,
  reviewList,
  onShowClick,
  onEditClick,
  isActive,
  title = "Review History",
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const isWithin24Hours = (dateString) => {
    const hoursDiff = dayjs().diff(dayjs(dateString), "hour");
    return hoursDiff < 24;
  };


  const columns = [
    {
      title: "Created By",
      dataIndex: "created_by_first_name",
      key: "created_by_first_name",
      ellipsis: true,
      width: isMobile ? "40%" : undefined,
      render: (value, record) => `${value} ${record?.created_by_last_name}`,
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      width: isMobile ? "34%" : undefined,
      render: (value) =>
        isMobile ? (
          <span className={styles.dateCell}>
            <span>{dayjs(value)?.format("DD MMM")}</span>
            <span>{dayjs(value)?.format("hh:mm A")}</span>
          </span>
        ) : (
          dayjs(value)?.format("DD, MMM hh:mm A")
        ),
    },
    {
      title: "",
      key: "actions",
      width: isMobile ? "26%" : 100,
      render: (_, record) => (
        <Space size={isMobile ? 6 : 8} wrap>
          <Typography.Link onClick={() => onShowClick(record)}>
            Show
          </Typography.Link>
          {isWithin24Hours(record.created_at) && isActive && onEditClick && (
            <Typography.Link onClick={() => onEditClick(record)}>
              Edit
            </Typography.Link>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      title={title}
      width={isMobile ? "min(92vw, 360px)" : 520}
      centered={isMobile}
      className={styles.reviewHistoryModal}
      destroyOnClose
    >
      <Table
        columns={columns}
        dataSource={reviewList}
        pagination={false}
        rowKey="id"
        size="small"
        scroll={undefined}
      />
    </Modal>
  );
};

export default ReviewModal;
